import React from 'react';

const RenderTable = ({ headers = [], rows = [] }) => {
  if (!headers.length || !rows.length) return <p>No data available</p>;

  const earliestDate = rows.reduce((earliest, row) => {
    const rowDate = new Date(row.date);
    return (!earliest || rowDate < earliest) ? rowDate : earliest;
  }, null);

  const filteredRows = rows.filter(row => {
    const rowDate = new Date(row.date);
    return rowDate.getTime() === earliestDate.getTime();
  });

  const sortedRows = filteredRows.sort((a, b) => Number(a.block_no) - Number(b.block_no));
  return (
    <div style={{ maxHeight: '250px', overflow: 'auto', border: '1px solid #ccc', borderRadius: '8px' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            {headers.map((header) => (
              <th
                key={header.name}
                style={{ position: 'sticky', top: 0, background: '#f2f2f2', padding: '8px', borderBottom: '1px solid #ccc' }}
              >
                {header.name}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, idx) => (
            <tr key={idx}>
              {headers.map((header) => (
                <td key={header.name} style={{ padding: '8px', borderBottom: '1px solid #eee' }}>
                  {row[header.name]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RenderTable;
